export default "__VITE_ASSET__050f654c__"